import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_13 = {
  class: "text-warning",
  style: {"color":"yellow"}
}
const _hoisted_14 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = {
  key: 2,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_17 = { class: "text-info" }
const _hoisted_18 = {
  key: 3,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_19 = { class: "text-danger" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_29 = {
  class: "modal fade createNewModal",
  id: "AddImageModal",
  tabindex: "-1",
  ref: "addAddImageModalRef",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_31 = { class: "modal-content p-15 p-md-40" }
const _hoisted_32 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25 text-center" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_EditAbonnePassModal = _resolveComponent("EditAbonnePassModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.checkPermission('AddAbonne'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-abonne"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Ajouter un abonné ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un abonne"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " NOM & PRENOMS ou DENOMINATION "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " TéLéPHONE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " MAIL "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " SEXE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " CATEGORIE D'ABONNE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " SECTEUR D'ACTIVITE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abonnes, (abonne, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("p", null, _toDisplayString(abonne.nomComplet.length > 35 ? abonne.nomComplet.substring(0, 35) + '...' : abonne.nomComplet), 1)
                  ]),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(abonne.telephone), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("p", null, _toDisplayString(abonne.email), 1)
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("p", null, _toDisplayString(abonne.sexe), 1)
                  ]),
                  (abonne?.categorieAbonne?.code == 'Catégorie 1')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(abonne?.categorieAbonne?.libelle.length > 25 ? abonne?.categorieAbonne?.libelle.substring(0, 25) + '...' : abonne?.categorieAbonne?.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (abonne?.categorieAbonne?.code == 'Catégorie 2')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(abonne?.categorieAbonne?.libelle.length > 25 ? abonne?.categorieAbonne?.libelle.substring(0, 25) + '...' : abonne?.categorieAbonne?.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (abonne?.categorieAbonne?.code == 'Catégorie 3')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(abonne?.categorieAbonne?.libelle.length > 25 ? abonne?.categorieAbonne?.libelle.substring(0, 25) + '...' : abonne?.categorieAbonne?.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (abonne?.categorieAbonne?.code == 'Catégorie 4')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(abonne?.categorieAbonne?.libelle.length > 25 ? abonne?.categorieAbonne?.libelle.substring(0, 25) + '...' : abonne?.categorieAbonne?.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("p", null, _toDisplayString(abonne?.activite?.libelle), 1)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_23, [
                        (_ctx.checkPermission('ViewAbonne'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              _createVNode(_component_router_link, {
                                to: { name: 'ViewAbonnePage', params: { id: abonne.id } },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-2" }, null, -1),
                                  _createTextVNode("Détails", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('EditAbonne'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                              _createVNode(_component_router_link, {
                                to: { name: 'EditAbonnePage', params: { id: abonne.id } },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode("Modifier", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (abonne.urlImage)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddImageModal",
                                onClick: ($event: any) => (_ctx.showImage(abonne.urlImage))
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Voir l'image ", -1)
                              ]))], 8, _hoisted_27)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
            _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Fichier actuel")
          ], -1)),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.isImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.image,
                  alt: "Image"
                }, null, 8, _hoisted_33))
              : (_ctx.isPdf)
                ? (_openBlock(), _createElementBlock("embed", {
                    key: 1,
                    src: _ctx.image,
                    width: "500",
                    height: "500",
                    type: "application/pdf"
                  }, null, 8, _hoisted_34))
                : (_openBlock(), _createElementBlock("p", _hoisted_35, "Format de fichier non supporté"))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512),
    _createVNode(_component_EditAbonnePassModal, { selectedUser: _ctx.selectedUser }, null, 8, ["selectedUser"])
  ], 64))
}